import RawApiClient, {
  throwNon200ResponseTransformer,
  parseBodyAsJsonResponseTransformer,
  buildRequestHeadersTransformer,
  HttpError,
} from "./RawApiClient";
import { fetchAllPages } from "../capiClient/Pager";
import getEnvironmentRequestTransformer from "./getEnvironmentRequestTransformer";
let rawCapiClient;
// RawCapiClient has some additional methods specific to CAPI
export class RawCapiClient extends RawApiClient {
  getAll(path, params = {}) {
    return fetchAllPages(path, params, rawCapiClient);
  }
}
class CapiError extends HttpError {
  constructor(m) {
    super(m);
    // Set the prototype explicitly because when this is transpiled to ES5, it
    // uses a class constructor pattern that won't properly extend the builtin
    // Error class. See:
    // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
    Object.setPrototypeOf(this, CapiError.prototype);
  }
}
const addAcceptHeader = buildRequestHeadersTransformer({
  Accept: "application/vnd.plangrid+json; version=1",
});
const handleCapiErrorResponseTransformer = {
  then(response) {
    return Promise.resolve(response);
  },
  catch(error) {
    // If it is a JSON parse error or network error, no hope to retrieve the body
    if (!error.json || !error.response) {
      throw error;
    }
    // All CAPI errors have a "message" property that we include in the Error message and then
    // re-throw
    const json = error.json;
    error.capiMessage = json.message;
    error.capiErrors = json.errors;
    error.message = `${error.json.message} (${error.response.status} ${error.response.statusText})`;
    throw error;
  },
};
rawCapiClient = new RawCapiClient({
  requestTransformers: [
    getEnvironmentRequestTransformer("capi"),
    addAcceptHeader,
  ],
  responseTransformers: [
    throwNon200ResponseTransformer,
    parseBodyAsJsonResponseTransformer,
    handleCapiErrorResponseTransformer,
  ],
});
export default rawCapiClient;
